import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "speed-1.5x--sprite",
  "use": "speed-1.5x--sprite-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"speed-1.5x--sprite\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.5 10H5v1h2v10H5v1h5v-1H8V10h-.5zm6 0H13v6.5h4V21h-4v1h5v-6.5h-4V11h4v-1h-4.5zM11 21h1v1h-1v-1zm9.646-5.146l2.647 2.646-2.647 2.646.708.708L24 19.207l2.646 2.647.708-.708-2.647-2.646 2.647-2.646-.708-.708L24 17.793l-2.646-2.647-.708.708z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol